import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function useRequestFromParams() {
  const [requestFromParams, setRequestFromParams] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const preview = searchParams.get("preview");

    if (preview === "true") {
      setRequestFromParams({
        description: searchParams.get("description"),
        platform: searchParams.get("platform").split(","),
        tone: searchParams.get("tone"),
        otherTone: searchParams.get("otherTone"),
        captionCount: parseInt(searchParams.get("captionCount")),
        useHashtags: searchParams.get("useHashtags") === "true",
        useEmojis: searchParams.get("useEmojis") === "true",
      });
    }
  }, []);

  return requestFromParams;
}
